import React  , { useEffect} from 'react'
import { useNavigate } from 'react-router-dom';

//redux
import {useSelector} from  'react-redux'

//mui
import { Box } from '@mui/material';

//componets
// import LogIn from './Account/registrationForm/Login'
import Home from './Home/Home';
import Authentication from './Authentication/Authentication';


export default function Messenger() {

  const navigate = useNavigate();
   let auth = localStorage.getItem('auth');

   useEffect(()=>{
      if(!auth){
           navigate('Authentication');
      }
   },[]);

  return (
    <Box>
      {
        auth ? <Home/> : <Authentication/>
      }
    </Box>
  )
}
